/** @format */

import { useContext, useLayoutEffect } from "react";
import { Context } from "../../stores/Provider";
import { Outlet } from "react-router-dom";

const AgentRootBeforeRender = ({ agentPath }: { agentPath: string }) => {
  const { dispatch } = useContext(Context);
  const zAccount = agentPath.substring(1);
  useLayoutEffect(() => {
    dispatch({
      type: "set-context-data",
      payload: {
        agentPath: agentPath,
        zAccount: zAccount,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <Outlet />;
};

export default AgentRootBeforeRender;
